import InvoiceRow from "./InvoiceRow";

export default function InvoiceTable({
  invoices,
  loading,
  onClearFilters,
  hasFilters,
  onReprint
}) {
  if (loading) {
    return (
      <div className="text-center mt-4">
        <div className="spinner"></div>
        <p className="mt-2">Loading invoices...</p>
      </div>
    );
  }

  return (
    <div className="table-container">
      <table className="table">
        <thead>
          <tr>
            <th>INVOICE #</th>
            <th>CUSTOMER</th>
            <th>DATE</th>
            <th>TOTAL</th>
            <th>PDF</th>
            <th>REPRINT</th>
          </tr>
        </thead>

        <tbody>
          {invoices.length === 0 ? (
            <tr>
              <td colSpan={6} className="text-center">
                <div className="no-data">
                  <p>📭 No invoices to show</p>
                  {hasFilters && (
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={onClearFilters}
                    >
                      Clear filters
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ) : (
            invoices.map((invoice) => (
              <InvoiceRow
                key={invoice.id}
                invoice={invoice}
                onReprint={onReprint}
              />
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}